"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onBrowserInit = void 0;
var tslib_1 = require("tslib");
var hook_context_1 = require("../hook-context");
var hook_runner_1 = require("../hook-runner");
/**
 * Provides access to the earliest phase of JavaScript loading within the browser.
 * This hook is where you would bootstrap any modules in your application that need incredibly early initialization.
 * Some common examples of plugins that might use this hook are ones that need to monkey patch other modules before anything else really uses them,
 * such as React rendering validators (accessibility, performance) or error wrappers.
 *
 * TODO: should rename to onBrowserInit / executeOnBrowserInit
 */
var onBrowserInit = function (plugins, context) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var state, hookArgs;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = context.state;
                hookArgs = (0, hook_context_1.buildHookContext)('onBrowserInit', tslib_1.__assign(tslib_1.__assign({}, context), { hydratedState: {} }));
                return [4 /*yield*/, (0, hook_runner_1.runHook)(plugins, 'onBrowserInit', hookArgs, {
                        pre: function (args, plugin) {
                            var hydratedState = state[plugin.name];
                            return tslib_1.__assign(tslib_1.__assign({}, args), { hydratedState: hydratedState });
                        },
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.onBrowserInit = onBrowserInit;
//# sourceMappingURL=on-browser-init.js.map